export default class IrszaminputClass {

    constructor() {
        this.API_KEY = window.GOOGLE_API_KEY;
    }

    initInput() {
        // csak ha az url tartalmazza a 'geotest' paramétert
        if (window.location.href.indexOf('geotest') == -1) {
            return;
        }

        if ($('input[name="irszam"]').length > 0) {

            $('input[name="irszam"]').on('change blur', function () {
                window.IrszamInput.getCity($(this).val());
            });

            $('input[name="irszam"]').on('keyup', function () {
                if ($(this).val().length == 4) {
                    window.IrszamInput.getCity($(this).val());
                }
            });
        }
    }

    getCity(irszam) {
        var url = 'https://maps.googleapis.com/maps/api/geocode/json?components=country:HU|postal_code:' + irszam + '&key=' + this.API_KEY;

        $.ajax({
            url: url,
            dataType: 'json',
            success: function (data) {
                if (data.status == 'OK') {
                    var city = data.results[0].address_components[1].long_name;
                    $('input[name="varos"]').val(city).trigger('keyup');
                }
            }
        });
    }

}
